import { request } from './client';

export function getSections() {
  return request('/api/store/v1/sections');
}
